import { render } from "./EditEmailTemplates.vue?vue&type=template&id=45217d7d"
import script from "./EditEmailTemplates.vue?vue&type=script&lang=js"
export * from "./EditEmailTemplates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__